export default "__VITE_ASSET__Cla_vSMI__"